<template>
  <div class="marqueedzp">
    <img v-if="pageBg" v-lazy="pageBg && pageBg[0] && pageBg[0].img" />
    <div class="rule" @click="getRuleShow">
      <img v-lazy="ruleImg && ruleImg[0] && ruleImg[0].img" />
    </div>
    <div class="dzpbg">
      <div class="dzpimg" id="dzpimg" v-if="dzpImg">
        <img :src="dzpImg && dzpImg[0] && dzpImg[0].img" alt="" />
      </div>
      <div class="dzpbtn" @click="lottery"></div>
    </div>
    <p class="myglod">
      还剩 <i>{{ myGolds }}</i> 次机会
    </p>
    <div class="btn">
      <router-link to="home"
        ><img v-lazy="btnImg && btnImg[0] && btnImg[0].img"
      /></router-link>
      <router-link
        :to="{
          path: 'couponCenter',
          query: { name: 'couponCenter', title: '我的奖品' },
        }"
        ><img v-lazy="btnImg && btnImg[1] && btnImg[1].img"
      /></router-link>
    </div>
    <rule @ruleClose="ruleClose" :rule="objRule" />
    <get-card :objGetCard="objGetCard" @getCardClose="getCardClose" />
    <get-nocard
      :getNocardShow="getNocardShow"
      @getNocardClose="getNocardClose"
    />
  </div>
</template>
<script>
import api from '../../../utils/api'
import rule from './Rule.vue'
import getCard from './GetCard.vue'
import getNocard from './NoCard.vue'
let flag = false
let sn
let blocksum = 6
export default {
  components: {
    rule, getCard, getNocard
  },
  data () {
    return {
      myGolds: 0,
      btnImg: [],
      dzpImg: [],
      pageBg: [],
      ruleImg: [],
      getNocardShow: false,
      objGetCard: {
        show: false,
        text: ''
      },
      objRule: {
        show: false,
        text: ''
      },
      lotteryId: 0
    }
  },
  activated () {
    if (this.lotteryId) {
      this.getGolds(this.lotteryId)
    }
  },
  watch: {
    lotteryId () {
      this.getGolds(this.lotteryId)
    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.getPageJson()
  },
  methods: {
    getRuleShow () {
      this.objRule.show = true
    },
    async lottery () {
      if (this.myGolds <= 0) {
        this.$toast('抽奖机会已用完')
        return false
      }
      if (flag) {
        return false
      }
      flag = true

      let angleValue = 0
      let mn = Math.floor(Math.random() * 100000)
      const myData = await this.$axios.post('api/lottery/tErnie', { id: this.lotteryId })
      if (myData.status === 200) {
        const { code, msg, data } = myData.data
        if (code === 0) {
          this.myGolds--
          if (data.prod_id === 1065) {
            sn = 2
          } else if (data.prod_id === 1072) {
            sn = 5
          } else if (data.prod_id === 1071) {
            sn = 6
          } else if (data.prod_id === 1967) {
            sn = 3
          } else {
            if (data.title.indexOf('包钢宾馆') === -1) {
              sn = 1
            } else {
              sn = 4
            }
          }
        } else {
          if (data.code === 4004) {
            this.myGolds--
            sn = 1
          } else {
            flag = false
            this.$toast(msg)
          }
        }
        angleValue = -sn * (360 / blocksum) + angleValue + 360 * mn + 360 / blocksum / 2
        document.getElementById('dzpimg').style.transform = `rotate(${angleValue}deg)`
        setTimeout(() => {
          if (sn === 1) {
            this.getNocardShow = true
          } else {
            this.objGetCard.text = data.title
            this.objGetCard.show = true
          }
          flag = false
        }, 3000)
      }
    },
    async getPageJson () {
      const data = await api.getJsonVersion('lottery')
      this.pageBg = data['lottery-1'] && data['lottery-1'].data
      this.ruleImg = data['lottery-2'] && data['lottery-2'].data
      this.dzpImg = data['lottery-3'] && data['lottery-3'].data
      this.btnImg = data['lottery-5'] && data['lottery-5'].data
      this.lotteryId = this.dzpImg && this.dzpImg[0] && this.dzpImg[0].skuid
      // this.getGolds(this.lotteryId)
      this.pageRule(this.lotteryId)
    },
    async pageRule (id) {
      const myData = await this.$axios.get(`api/lottery/rule/${id}`)
      if (myData.status === 200) {
        const { code, msg, data } = myData.data
        this.$toast.clear()
        if (code === 0) {
          this.objRule.text = data.content
        } else {
          this.$toast(msg)
        }
      }
    },
    async getGolds (id) {
      const myData = await this.$axios.get(`api/lottery/chance/${id}`)
      if (myData.status === 200) {
        const { code, msg, data } = myData.data
        if (code === 0) {
          this.myGolds = data.chance
        } else {
          this.$toast(msg)
        }
      }
    },
    getNocardClose () {
      this.getNocardShow = false
    },
    getCardClose () {
      this.objGetCard.show = false
    },
    ruleClose () {
      this.objRule.show = false
    }
  }
}
</script>
<style lang='less' scoped>
.marqueedzp {
  img {
    position: relative;
  }
  .rule {
    position: absolute;
    top: 0.3rem;
    right: 0.25rem;
    width: 1.3rem;
  }
  .btn {
    position: absolute;
    top: 15.2rem;
    left: 0.45rem;
    right: 0;
    display: flex;
    a {
      width: 2.82rem;
      height: 0.7rem;
      display: block;
      margin-right: 0.5rem;
    }
  }
  .myglod {
    position: absolute;
    top: 14.6rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: @fz26;
    color: #432d00;
    i {
      font-size: @fz28;
    }
  }
  .dzpbg {
    position: absolute;
    top: 6.6rem;
    left: 0.07rem;
    width: 7.4rem;
    height: 7.71rem;
    // background: url(./img/dzp.png) no-repeat;
    // background-size: 100% auto;
    overflow: hidden;
    .dzpimg {
      position: absolute;
      top: 0.33rem;
      left: 50%;
      margin-left: -3.5rem;
      width: 7rem;
      transition: all 3000ms ease;
    }
    .dzpbtn {
      position: absolute;
      top: 2.4rem;
      left: 2.52rem;
      width: 2.35rem;
      height: 2.65rem;
      background: url(./img/dzp-btn.png) no-repeat;
      background-size: 100% auto;
    }
  }
}
</style>
